import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from "rxjs";

@Injectable()
export class JsonDateInterceptor implements HttpInterceptor {

	// 2019-12-23T15:56:59.081-0300
	private readonly DATE_REGEXP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d*-\d{4}$/;

	intercept( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
		return next.handle( req ).pipe(
			map( (val:HttpEvent<any>) => {
				if( val instanceof HttpResponse ) {
					const body = val.body;
					this.convert( body );
				}
				return val;
			}));
	}

	private isDateString( value: any ): boolean {
		return value !== null && value !== undefined && typeof value === 'string'? this.DATE_REGEXP.test( value ): false;
	}

	private convert( body: any ): void {
		if( body !== null && body !== undefined && typeof body === 'object' ) {
			for( const key of Object.keys( body ) ) {
				const value = body[key];
				if( this.isDateString( value ) )
					body[key] = new Date( value );
				else if( typeof value === 'object' ) {
					this.convert( value );
				}
			}
		}
	}

}